import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_2 = { class: "form-row" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-row" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'modal-backdrop': !_ctx.isEmbedded }),
    onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (!_ctx.isEmbedded && _ctx.close()), ["self"]))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'modal-content': !_ctx.isEmbedded })
    }, [
      (!_ctx.isEmbedded)
        ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.isEditMode ? 'Edit Customer' : 'Add New Customer'), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
              class: "btn-close"
            }, "×")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", {
        class: _normalizeClass({ 'modal-body': !_ctx.isEmbedded })
      }, [
        _createElementVNode("form", {
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
          class: "booking-form"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { for: "firstName" }, "First Name *", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "firstName",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.firstName) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.firstName]
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { for: "lastName" }, "Last Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "lastName",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.lastName) = $event))
              }, null, 512), [
                [_vModelText, _ctx.form.lastName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { for: "email" }, "Email", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                id: "email",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.email) = $event))
              }, null, 512), [
                [_vModelText, _ctx.form.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { for: "phoneNumber" }, "Phone Number", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "tel",
                id: "phoneNumber",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.phoneNumber) = $event))
              }, null, 512), [
                [_vModelText, _ctx.form.phoneNumber]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { for: "dob" }, "Date of Birth", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                id: "dob",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.dob) = $event))
              }, null, 512), [
                [_vModelText, _ctx.form.dob]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { for: "gender" }, "Gender", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "gender",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.gender) = $event))
              }, _cache[17] || (_cache[17] = [
                _createElementVNode("option", { value: undefined }, "Select...", -1),
                _createElementVNode("option", { value: "Male" }, "Male", -1),
                _createElementVNode("option", { value: "Female" }, "Female", -1),
                _createElementVNode("option", { value: "Other" }, "Other", -1)
              ]), 512), [
                [_vModelSelect, _ctx.form.gender]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[19] || (_cache[19] = _createElementVNode("label", { for: "address" }, "Address", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "address",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.address) = $event)),
              rows: "3"
            }, null, 512), [
              [_vModelText, _ctx.form.address]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[20] || (_cache[20] = _createElementVNode("label", { for: "notes" }, "Notes (Allergies, Preferences)", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "notes",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.notes) = $event)),
              rows: "3"
            }, null, 512), [
              [_vModelText, _ctx.form.notes]
            ])
          ]),
          _createElementVNode("footer", {
            class: _normalizeClass(["form-footer", { 'modal-footer': !_ctx.isEmbedded }])
          }, [
            (!_ctx.isEmbedded)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, "Cancel"))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary",
              disabled: _ctx.isSubmitting
            }, _toDisplayString(_ctx.isSubmitting ? 'Saving...' : 'Save Customer'), 9, _hoisted_13)
          ], 2)
        ], 32)
      ], 2)
    ], 2)
  ], 2))
}